import { Outlet } from "react-router"
import { AdminSidebar } from "@/admin/components/admin-sidebar"
import { AdminHeader } from "@/admin/components/admin-header"
import styles from "./admin-layout.module.css"

export function AdminLayout() {
  return (
    <div className={styles.container}>
      <AdminSidebar />
      <div className={styles.content}>
        <AdminHeader />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}